<div class="container-area">
  @if(DESCOPE_PROJECT_ID) {
  <descope-wc [attr.project-id]="DESCOPE_PROJECT_ID"
              flow-id="sign-up-or-in"
              theme="light"
              (success)="onDescopeAuthorizationSuccess($event)"
              (error)="onDescopeAuthorizationError($event)"></descope-wc>
  }

  <!-- skeleton here -->

</div>

<nz-modal [nzVisible]="isLoginRequestModalVisible()"
          nzTitle="Waiting for Liife Mobile App Approval..."
          [nzWidth]="500"
          [nzHeight]="600"
          [nzFooter]="null"
          (nzOnCancel)="isLoginRequestModalVisible.set(false)">
  <ng-container *nzModalContent>
    <div class="approval-modal-content">
      <div class="approval-modal-content-header">
        <i class="fa-solid fa-clock fa-spin"></i>
      </div>
      <div class="approval-modal-content-body">
        <p>Please open your Liife Id or Liife Intake Mobile Application on your mobile device and approve the login
          request.</p>
        <p>Once approved, you will be allowed and redirected to the application.</p>
      </div>
    </div>
  </ng-container>
</nz-modal>